
// Module
import { useRef, useEffect, useState } from 'react';

// CSS
import '_Asset/css/User/Page/design.css'
import '_Asset/css/User/Page/UiComponent/palette.css'

// Component
import { Palette, Navigation, Button, Input, Table, Dropdown, Modal, Text, UIElement } from 'User/Page';


const UIComponent = () => {

  const tabGroupRef = useRef(null);
  const tabBarRef = useRef(null);
  const [currentTab, setCurrentTab] = useState(0);
  const [tabClickIdx, setTabClickIdx] = useState(0);
  
  const menuArr = [
    { name: 'UI Colors', component: <Palette /> },
    { name: 'Buttons', component: <Button /> },
    { name: 'Inputs', component: <Input /> }, // 일반 Input, File Type, Textarea
    { name: 'Dropdowns', component: <Dropdown /> }, // Select Box, Date picker...
    { name: 'Navigation', component: <Navigation /> }, // Tabs, Pagination
    { name: 'Tables', component: <Table /> },
    { name: 'Modal', component: <Modal /> }, // Modal, Toast...
    { name: 'Text', component: <Text /> },
    { name: 'UI Elements', component: <UIElement /> }, // Combined Elements, CheckBox, Radio Button, Toggle Button... 
    // { name: 'Headers', component: <Header /> },
    // { name: 'Footers', component: {/* <Footer /> */} },
    // { name: 'Side Bars', component: <SideBar /> },
  ]

  const [btnSize, setBtnSize] = useState('');
  const [centerBlock, setCenterBlock] = useState('');
  const [remainder, setRemainder] = useState('');
  const [maxClickIdx, setMaxClickIdx] = useState('');

  useEffect(() => {
    let barWidth = tabBarRef.current?.clientWidth // 가려진 버튼 포함 전체 width 값 
    let groupWidth = tabGroupRef.current?.clientWidth // 현재 보여지는 버튼 전체 width 값
    let btnSizeTemp = barWidth / menuArr.length // 버튼 개당 사이즈
    let curBlock = Math.floor(groupWidth / btnSizeTemp) // 현재 보여지는 버튼 갯수

    setBtnSize(btnSizeTemp);
    setCenterBlock(Math.floor(curBlock / 2));
    setRemainder(groupWidth % btnSizeTemp); // Tab bar 나머지 버튼 길이
    setMaxClickIdx(menuArr.length - curBlock); // 최대 클릭 가능 횟수
    
  }, [tabGroupRef, tabBarRef])
    

  // UI Component Source 복사 
  const [toastState, setToastState] = useState(false);
  const [copyText, setCopyText] = useState('');

  const copySource = (targetClass) => {
    const target = document.querySelectorAll(targetClass);
    const targetPalette = document.querySelectorAll(targetClass + ' + .colorInfo p');
    
    target.forEach((t, i) => {
      t.addEventListener('mouseenter', () => {
        t.setAttribute('title', `클릭하면 ${targetClass === '.plt' ? '색상코드' : '태그'}를 복사 할 수 있습니다.`)
      })
      t.addEventListener('mouseleave', () => {
        t.removeAttribute('title')
      })
      t.addEventListener('click', () => {
        t.setAttribute('title', '')
        const copyTxt = t.cloneNode(true);
        let copyTemp = document.createElement('textarea');
        document.body.appendChild(copyTemp);

        if (targetClass === '.plt') {
          targetPalette.forEach((t2, idx) => {
            if (i === idx) {
              copyTemp.textContent = t2.innerHTML;
            }
          })
        } else {
          copyTemp.textContent = copyTxt.outerHTML;
        }
        
        copyTemp.select();
        document.execCommand('copy');
        document.body.removeChild(copyTemp);

        setCopyText(copyTemp.textContent);    
        setToastState(true);
      })
    })
  }

  useEffect(() => {
    if (toastState) {
      setTimeout(() => { setToastState(false); }, 4800);
    }
  }, [toastState])

  useEffect(() => {
    const objDom = [
      {item: ".plt"}, // UI Colors
      {item: ".contWrap .btn"},
      {item: ".contWrap .input"},
      {item: ".contWrap .textarea"},
      {item: ".contWrap.file .field"},
      {item: ".contWrap .select"},
      {item: ".contWrap .tabGroup"},
      {item: ".contWrap .pagination"},
      {item: ".contWrap .table"},
      {item: ".contWrap .toast"},
      {item: ".layoutCont .modal"},
      {item: ".contWrap .msgBox"},
      {item: ".contWrap .check"},
      {item: ".contWrap .switchBtn"},
      {item: ".contWrap .tagBox"},
    ]
    const chkDom = objDom.filter(itm => document.querySelector(itm.item))
    if(chkDom.length !== 0 && chkDom[0].item){
      chkDom.map(itm => {
        copySource(itm.item)
      })
    }
  })

  return (
    <>
      {/* Visual */}
      <div className="visual design">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">UI Components</h2>
            
            <p className="visualTxt">The relevant information and any improvements made on UI design and principles are available in the following topics below.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">

        {/* Component Area */}
        <div className="section">
          <div className="componentArea areaBox">
            <button type="button" className={`icofont-rounded-left arrow ${tabClickIdx !== 0 ? 'on' : 'off'}`} onClick={() => tabClickIdx !== 0 && setTabClickIdx(tabClickIdx - 1)}></button>
            <div className="tabGroup type_3 sfrtBlue" ref={tabGroupRef}>
              <div className="tabBar" style={{left: `-${btnSize * tabClickIdx - (maxClickIdx === tabClickIdx ? remainder : 0)}px`}} ref={tabBarRef}>
                {menuArr.map((ele, i) => 
                  <button type="button" key={i} className={`btn sm ${currentTab === i ? 'active' : ''}`} onClick={() => {setCurrentTab(i); (i - centerBlock >= 0 && i + centerBlock <= menuArr.length-1) ? setTabClickIdx(i - centerBlock) : i - centerBlock >= 0 ? setTabClickIdx(maxClickIdx) : setTabClickIdx(0)}}>{ele.name}</button>
                  )}
              </div>
            </div>
            <button type="button" className={`icofont-rounded-right arrow ${maxClickIdx > tabClickIdx ? 'on' : 'off'}`} onClick={() => maxClickIdx > tabClickIdx && setTabClickIdx(tabClickIdx + 1)}></button>

            {menuArr[currentTab].component}
          </div>
        </div>
      </div>

      <div className={`toast ${toastState ? 'show' : ''}`}>
        <div className={`toastBox success`}>
          <div className="toastStatus">
            <p className="icofont-verification-check"></p>
          </div>

          <div className="toastMsg">
            <h2>태그 복사 완료</h2>
            <p>
              태그를 성공적으로 복사하였습니다.<br />
              {copyText}
            </p>
          </div>

          <div className="toastClose">
            <button type="button" className="icofont-close-line" onClick={() => setToastState(false)}></button>
          </div>
        </div>
      </div>
    </>
  )
}
  
export default UIComponent;

